
export default {
    deficiencia: {},
    deficiencias: []
}